var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-radio-list',{attrs:{"id":_vm.id,"label":_vm.label,"validationFieldLabel":_vm.validationFieldLabel,"validationInvalidFeedback":_vm.validationInvalidFeedback,"values":_vm.values},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }